import {BaseState} from "../../BaseState";
import {RejectError} from "../../error/Error";
import {CacheClearJobStatus} from "../deleteUrls/DeleteUrlsState";
import {BulkDeletePreviewResult} from "../../../services/UrlsService";

export enum BulkDeleteClientErrorReason {
  notCsv = "notCsv",
  tooLarge = "tooLarge"
}

export interface BulkDeleteClientError {
  readonly reason: BulkDeleteClientErrorReason;
  readonly message: string;
}

export default interface BulkDeleteUrlsState extends BaseState {
  readonly clientError: BulkDeleteClientError | null;
  readonly preview: BulkDeletePreviewResult | null;
  readonly previewError: RejectError | null;
  readonly confirmError: RejectError | null;
  readonly jobStatus: CacheClearJobStatus;
  readonly deletedCount?: number;
}
